import type { WatermarkSegment } from "../../../../api/types/investorPortalTypes";

export const watermarkSegmentCaptionMap: Record<WatermarkSegment, string> = {
  CustomText: "Custom Text",
  ContactName: "Contact Name",
  ContactEmail: "Contact Email",
  InvestorName: "Investor Name",
  DateAndTime: "Date",
};
